import { useState } from 'react';
import type React from 'react';

import { Box } from '@mui/material';
import { FiqlInput, OrdList, OrdTitle, type OrdListProps } from '@ragu-components/ord-components';
import { CallSessionEventFields } from '@ragu-components/ord-types';
import { ResourceContextProvider, useTranslate } from 'react-admin';
import { useParams } from 'react-router-dom';

import { Resources } from 'src/lib/resources';

import { CallSessionEventsTreeView } from './components/CallSessionEventsTreeView';
import { CallSessionInfo } from './components/CallSessionInfo';
import { useCallSessionEventTitle } from './utils/callSessionEventsUtils';

export const CallSessionEventsList = (props: Partial<OrdListProps>): React.ReactElement => {
  const { id } = useParams<'id'>();
  const translate = useTranslate();
  const [showAdvanced, setShowAdvanced] = useState(false);

  const title = useCallSessionEventTitle(translate('resources.call_session_events.name'));

  if (id === undefined) {
    return <></>;
  }

  return (
    <OrdList
      {...props}
      resource={`call_sessions/${id}/call_session_events`}
      quickFilters={[
        <FiqlInput
          key='ts_event_after'
          type='date-time'
          source='ts_event_after'
          fiqlField={CallSessionEventFields.ts_event}
          operator='=gt='
          label='ord.filters.range.after'
        />,
        <FiqlInput
          key='ts_event_before'
          type='date-time'
          source='ts_event_before'
          fiqlField={CallSessionEventFields.ts_event}
          operator='=lt='
          label='ord.filters.range.before'
        />,
      ]}
      sort={{ field: CallSessionEventFields.ts_event, order: 'ASC' }}
      icon={<></>}
      // Using some big number to get all events
      perPage={100000}
      pagination={false}
      actions={
        <ResourceContextProvider value={Resources.call_sessions}>
          <OrdTitle title={title} variant='body1' sx={{ p: '4px 16px' }} />
        </ResourceContextProvider>
      }
    >
      <Box p={0.5} sx={{ height: 'calc(100vh - 136px)', overflowY: 'auto' }}>
        <CallSessionInfo callSessionId={id} showAdvanced={showAdvanced} setShowAdvanced={setShowAdvanced} />
        <CallSessionEventsTreeView showAdvanced={showAdvanced} />
      </Box>
    </OrdList>
  );
};

export default CallSessionEventsList;
